module.exports = __webpack_public_path__ + "static/media/Steve_GD3C2732_RG.7a203459.jpg";